import { useEffect, useMemo, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {
  ArrowIcon,
  CaptureFallbackIcon,
  CloseIcon,
  DotIcon,
  RadioBoxActiveIcon,
  RadioBoxInActiveIcon
} from "../../Assets/assets";
import { isValidArray } from "../../Services/validators";
import { CaptureItem } from "../Cards/Cards";
// import {
//   ChartCarousel,
//   TableCarousel,
//   UploadPictureAndCarousel
// } from "../Carousels/Carousels";
// import { useRef } from "react";
// import { Carousel } from "react-responsive-carousel";
// import { ArrowIcon, GoToLogo, UploadIcon } from "../../Assets/assets";
// import { isValidObject } from "../../Services/validators";
// import {
//   complaintsTableField,
//   convertToTableData,
//   getMonthlyComparisonBarChartData,
//   getRaisedChartData,
//   getStatusChartData
// } from "../../Utils/Constants/Complaints";
// import {
//   convertProcedureHistoryToTableData,
//   procedureHistoryTableField
// } from "../../Utils/Constants/ProcedureHistory";
import { reportsFilterData } from "../../Utils/Constants/Reports";
// import { workforceTableField } from "../../Utils/Constants/Workforce";
// import { LegendCard } from "../Cards/Cards";
// import CropperModal from "../CropperModal/CropperModal";
import SingleSelect from "../Filters/SingleSelect";
// import BarChart from "../Graphs/BarChart";
// import { DoughnutChart } from "../Graphs/DoughnutChart";
import Modal from "../Modal/Modal";
// import Table from "../Table/Table";
import { updateLocationStatus } from "../../Redux/locations/action";
import {
  alignPhoneNumber,
  dateAndTimeConverter
} from "../../Utils/Constants/Constants";
import Button from "../Button/Button";
import InputBox from "../InputBox/InputBox";

export default function LocationPreview(props) {
  const [selectedFilters, setSelectedFilters] = useState({
    month: [new Date().toLocaleString("default", { month: "long" })],
    year: [+new Date().getFullYear()]
  });
  const [selectedDay, setSelectedDay] = useState(null);
  const [showStatusModal, setShowStatusModal] = useState(false);

  useEffect(() => {
    let from, to;
    const month = reportsFilterData()[0].options.indexOf(
      selectedFilters.month?.[0]
    );
    const year = selectedFilters.year?.[0];

    if (selectedDay === null) {
      from = new Date(year, month, 1, 0, 0, 0, 0).getTime();
      to = new Date(year, month + 1, 0, 23, 59, 59, 999).getTime();
    } else {
      from = new Date(year, month, selectedDay, 0, 0, 0, 0).getTime();
      to = new Date(year, month, selectedDay, 23, 59, 59, 999).getTime();
    }
    props.fetchSelectedLocationData({ from, to });
    // props.fetchLocationsAssets(props.locationData?.data?.documentId);
    // eslint-disable-next-line
  }, [selectedDay, selectedFilters]);

  const getFilteredMonths = () => {
    const currentDate = new Date();
    const selectedYear = selectedFilters.year?.[0];
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    const allMonths = reportsFilterData()[0].options;
    const baseFilter = reportsFilterData()[0];

    if (selectedYear < currentYear) {
      return baseFilter;
    } else if (selectedYear === currentYear) {
      return {
        ...baseFilter,
        options: allMonths.slice(0, currentMonth + 1)
      };
    } else {
      return {
        ...baseFilter,
        options: []
      };
    }
  };
  useEffect(() => {
    if (typeof selectedDay === "number") {
      setSelectedDay(null);
    }
    // eslint-disable-next-line
  }, [selectedFilters]);
  return (
    <Modal
      show={true}
      canIgnore={true}
      onClose={() => {
        props.navigate("/locations/overview");
        props.setSelectedLocationData(null);
      }}
      height="inherit-parent-height"
      width="width-488px"
      minWidth="none"
      borderRadius="none"
      background="background-color-tertiaryColor2"
      position="position-absolute bottom-0 right-0"
    >
      <div
        className=" inherit-parent-width inherit-parent-height display-flex flex-direction-column"
        style={{ opacity: showStatusModal ? "40%" : "100%" }}
      >
        {/* Header */}
        <div className="margin-horizontal-large padding-top-large display-flex flex-justify-content-space-between flex-align-items-center padding-bottom-large">
          <div className="padding-right-large">
            <div className="display-flex">
              <div className="font-color-tertiaryColor">
                PCT #{props.locationData?.data?.PCTNo} -{" "}
                {props.locationData?.data?.location}
              </div>
              {/* <div
                onClick={props.editOnClick}
                data-cy="EDIT-ICON"
                className="cursor-pointer margin-left-default"
                style={{ height: "20px", width: "20px" }}
              >
                <EditIcon
                  height="20"
                  width="20"
                  color="var(--tertiaryColor6)"
                />
              </div> */}
            </div>
            <div
              className="display-flex flex-align-items-center font-size-small padding-top-small font-color-tertiaryColor6"
              style={{ gap: "4px" }}
            >
              Ward: {props.locationData?.data?.ward} <DotIcon />
              Zone: {props.locationData?.data?.zone}
              {/* <DotIcon /> */}
              {/* {props.locationData?.data?.category} */}
            </div>
          </div>

          <div className="display-flex">
            <div
              className="padding-right-larger display-flex cursor-pointer"
              onClick={() => setShowStatusModal(true)}
            >
              <div
                style={{
                  color:
                    props.locationData?.data?.operationalStatus?.state ===
                    "Inactive"
                      ? "#D0405A"
                      : "#20C74F"
                }}
              >
                {props.locationData?.data?.operationalStatus?.state}
              </div>
              <div className="display-flex flex-align-items-center padding-left-small">
                <ArrowIcon
                  color={
                    props.locationData?.data?.operationalStatus?.state ===
                    "Inactive"
                      ? "#D0405A"
                      : "#20C74F"
                  }
                />
              </div>
            </div>

            <div
              onClick={() => {
                props.navigate("/locations/overview");
                props.setSelectedLocationData(null);
              }}
              data-cy="CLOSE-ICON"
              className="cursor-pointer display-flex flex-align-items-center"
            >
              <CloseIcon color="var(--tertiaryColor6)" />
            </div>
          </div>
        </div>
        <div
          className="inherit-parent-width padding-horizontal-large "
          style={{ gap: "16px", height: "calc(100% - 73px)" }}
        >
          {/* <div style={{ width: "calc(100%  * 2 / 3 - 16px)" }} className="">
            <div
              className="display-flex"
              style={{ marginBottom: "16px", gap: "16px" }}
            >
              <div style={{ width: "50%" }}>
                <UploadPictureAndCarousel
                  onUpload={props.uploadLocationImage}
                  locationId={props.locationData?.data?.documentId}
                  setErrorStatus={props.setErrorStatus}
                  images={props.locationData?.data?.fileSrc?.images || []}
                />
              </div>
              <div
                style={{
                  width: "calc(50% - 2px)",
                  backgroundColor: "var(--tertiaryColor1)",
                  border: "1px solid var(--tertiaryColor5)"
                }}
              >
                <iframe
                  style={{
                    filter:
                      getComputedStyle(
                        document.documentElement
                      ).getPropertyValue("--primaryColor") === "#0E0E0E"
                        ? "grayscale(70%) invert(100%) contrast(90%)"
                        : "",
                    border: "none"
                  }}
                  title="PCT Map"
                  width="100%"
                  height="100%"
                  src={`https://www.google.com/maps?q=${props.locationData?.data?._geoloc?.lat},${props.locationData?.data?._geoloc?.lng}&z=16&output=embed`}
                  allowFullScreen
                />
              </div>
            </div>

            <ChartCarousel
              summary={props.locationData?.summaryData}
              theme={props.theme}
            />

            <TableCarousel
              complaints={props.locationData?.complaints}
              procedureHistory={props.locationData?.procedureHistory}
              workforce={props.locationData?.workforce}
            />
          </div> */}
          <div className="inherit-parent-height inherit-parent-width flex-direction-column flex-justify-content-space-between">
            <div
              className="display-flex flex-align-items-center position-relative"
              style={{ gap: "16px" }}
            >
              <SingleSelect
                data-cy="MONTH-SINGLE"
                data={getFilteredMonths()}
                array={true}
                setSelectedFilters={setSelectedFilters}
                selectedFilters={selectedFilters}
                appliedFilters={selectedFilters}
                selected={selectedFilters["month"]}
                onResetClick={() =>
                  setSelectedFilters((prev) => ({
                    ...prev,
                    month: [
                      new Date().toLocaleString("default", { month: "long" })
                    ]
                  }))
                }
              />
              <SingleSelect
                data-cy="YEAR-SINGLE"
                data={reportsFilterData()[1]}
                array={true}
                setSelectedFilters={setSelectedFilters}
                selectedFilters={selectedFilters}
                appliedFilters={selectedFilters}
                selected={selectedFilters["year"]}
                onResetClick={() =>
                  setSelectedFilters((prev) => ({
                    ...prev,
                    year: [+new Date().getFullYear()]
                  }))
                }
              />
            </div>
            <AttendanceCalendar
              attendanceData={props.locationData?.attendance}
              month={getFilteredMonths()?.options?.indexOf(
                selectedFilters.month?.[0]
              )}
              year={selectedFilters["year"]?.[0]}
              setSelectedDay={setSelectedDay}
              selectedDay={selectedDay}
              rolesData={props.rolesData}
              loading={props.locationData?.loading?.attendance}
            />
            <div
              className="margin-top-larger font-color-tertiaryColor6"
              style={{ height: "calc(100% - 424px)" }}
            >
              <div className="margin-bottom-large">CAPTURES</div>
              <div
                className="overflow-scroll"
                style={{ height: "calc(100% - 37px)" }}
              >
                {props.locationData?.captures &&
                isValidArray(Object.values(props.locationData?.captures)) ? (
                  Object.values(props.locationData?.captures).map(
                    (data, index) => (
                      <div key={index} data-cy="CAPTURE-CARD">
                        <CaptureItem
                          fileSrc={data?.fileSrc}
                          fields={[
                            {
                              key: "EMPLOYEE DETAILS",
                              value: `${
                                data?.employee?.name?.length > 15
                                  ? data.employee.name.slice(0, 15) + "..."
                                  : data?.employee?.name || "Surveillance"
                              }${
                                data?.employee?.phoneNumber
                                  ? `, ${alignPhoneNumber(
                                      data.employee.phoneNumber
                                    )}`
                                  : ""
                              }`
                            },
                            {
                              key: "CAPTURED AT",
                              value: data?.createdAt
                                ? `${dateAndTimeConverter(
                                    data.createdAt,
                                    "Time"
                                  )}, ${dateAndTimeConverter(
                                    data.createdAt,
                                    "cardDate"
                                  ) || "N/A"}`
                                : "N/A"
                            },
                            {
                              key: "LOCATION",
                              value: `${data?.location?.PCTNo || "N/A"}, ${
                                data?.location?.address?.length > 15
                                  ? data.location.address.slice(0, 15) + "..."
                                  : data?.location?.address || "N/A"
                              }`
                            }
                          ]}
                        />
                      </div>
                    )
                  )
                ) : (
                  <div className="display-flex font-color-tertiaryColor inherit-parent-height inherit-parent-width flex-justify-content-center flex-align-items-center">
                    <div className="display-flex flex-direction-column flex-align-items-center">
                      <CaptureFallbackIcon />
                      <div className="margin-top-large">
                        No capture data found
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <EditLocationStatusModal
        show={showStatusModal}
        currentStatus={props.locationData?.data?.operationalStatus}
        locationDocumentId={props.locationData?.data?.documentId}
        onClose={() => setShowStatusModal(false)}
        onSubmit={({ status, reason }) => {
          updateLocationStatus({
            locationId: props.locationData?.data?.documentId,
            status,
            reason
          });
        }}
      />
    </Modal>
  );
}

function AttendanceCalendar(props) {
  // const [isTransitioning, setIsTransitioning] = useState(false);

  const weekDays = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

  const isFutureDate = (day) => {
    const today = new Date();
    const dateToCheck = new Date(props.year, props.month, day);
    return dateToCheck > today;
  };

  const getDateStatus = (day) => {
    const dayData = props.attendanceData?.[props.year]?.[props.month]?.[day];
    if (isFutureDate(day)) return "future";
    if (dayData?.totalPercentage === 0 || !dayData?.totalPercentage)
      return "absent";
    if (dayData?.totalPercentage === 1) return "present";
  };

  const getDateStyle = (status) => {
    const baseStyle = {
      width: "40px",
      height: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: status === "future" ? "default" : "pointer",
      color: "var(--tertiaryColor6)"
    };

    const styles = {
      present: { background: "#20C74F29" },
      absent: {
        background: "#D0405A29"
        // border: "1px solid #D0405A99"
      },
      // offline: {
      //   background: "#D1754129",
      //   border: "1px solid #D1754199"
      // },
      future: {
        opacity: "50%"
      }
    };

    return { ...baseStyle, ...styles[status] };
  };

  const calendarDays = useMemo(() => {
    const daysInMonth = new Date(props.year, props.month, 0).getDate();
    const firstDayIndexOfMonth = new Date(props.year, props.month, 1).getDay();
    const days = Array(firstDayIndexOfMonth)?.fill(null);
    for (let day = 1; day <= daysInMonth; day++) days.push(day);
    return days;
  }, [props.month, props.year]);

  // const selectedData = attendanceData?.[year]?.[month + 1]?.[selectedDay] || {};

  const handleDayClick = (day) => {
    if (props.loading || isFutureDate(day)) {
      return;
    }
    props.setSelectedDay((prev) => (prev === day ? null : day));

    // setIsTransitioning(true);
    // setTimeout(() => {
    //   setSelectedDay(day);
    //   setIsTransitioning(false);
    // }, 200);
  };

  // const handleBackClick = () => {
  //   setIsTransitioning(true);
  //   setTimeout(() => {
  //     setSelectedDay(null);
  //     setIsTransitioning(false);
  //   }, 200);
  // };

  return props.loading ? (
    <div
      className={
        getComputedStyle(document.documentElement).getPropertyValue(
          "--primaryColor"
        ) === "#0E0E0E"
          ? "shimmer-dark"
          : "shimmer-light"
      }
      style={{ height: "320px", width: "456px" }}
    >
      {" "}
    </div>
  ) : (
    <div
      className="margin-horizontal-large inherit-parent-width  flex-justify-content-center "
      style={{ margin: "16px auto 0 auto" }}
    >
      <div
        // style={{
        //   opacity: isTransitioning ? 0 : 1,
        //   transform: isTransitioning ? "scale(0.95)" : "scale(1)",
        //   transition: "all 0.2s ease-out"
        // }}
        className="inherit-parent-width "
      >
        {/* {selectedDay === null ? ( */}
        <>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(7, 1fr)",
              marginBottom: "8px"
            }}
          >
            {weekDays.map((day) => (
              <div
                key={day}
                className="font-color-tertiaryColor6 padding-large text-align-center font-size-small"
              >
                {day}
              </div>
            ))}
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(7, 1fr)",
              gap: "16px 0"
            }}
          >
            {calendarDays.map((day, index) => (
              <div
                key={index}
                className="display-flex flex-align-items-center flex-justify-content-center position-relative"
              >
                {day && (
                  <div
                    style={{
                      ...getDateStyle(getDateStatus(day)),
                      border:
                        props.selectedDay === day &&
                        getDateStatus(day) === "absent"
                          ? "2px solid #D0405A99"
                          : props.selectedDay === day &&
                            getDateStatus(day) === "present"
                          ? "2px solid #20C74F99"
                          : "none"
                    }}
                    onClick={() => handleDayClick(day)}
                    data-cy={`DAY-${day}`}
                  >
                    {day}
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
        {/* ) 
        : (
          <div
            className={`font-color-tertiaryColor6 overflow-scroll  
                ${getComputedStyle(document.documentElement).getPropertyValue("--primaryColor") === "#0E0E0E"
                ? "background-color-tertiaryColor1" : "background-color-tertiaryColor9"}`}
            style={{ height: "300px", marginTop: "6px" }}
          >
            <div
              onClick={handleBackClick}
              className="display-flex flex-align-items-center cursor-pointer margin-bottom-large"
              style={{ padding: "16px 16px 0 16px" }}
              data-cy="CALENDAR-BACK-ICON"
            >
              <BackArrowIcon />
              <div className="margin-left-large">
                {`${String(selectedDay).padStart(2, "0")}-${String(
                  month + 1
                ).padStart(2, "0")}-${year}`}
                ,{" "}
                {new Date(year, month, selectedDay).toLocaleDateString(
                  "en-US",
                  {
                    weekday: "long"
                  }
                )}
              </div>
            </div>
            <div style={{ height: "193px" }} className="overflow-scroll padding-horizontal-large">
              {Object.entries(selectedData)
                .filter(([roleId, records]) => {
                  const role = rolesData?.[roleId];
                  return (
                    role &&
                    role.name !== "Support" &&
                    Array.isArray(records) &&
                    records.length > 0
                  );
                })
                .map(([roleId, records]) => (
                  <div key={roleId} style={{ marginBottom: "24px" }}>
                    <div className="text-uppercase font-size-medium">
                      {`${rolesData[roleId]?.name}(s) status`}
                    </div>
                    <div
                      className="display-flex flex-wrap margin-top-default"
                      style={{ gap: "24px" }}
                      data-cy={`${roleId}-STATUS`}
                    >
                      {records.map((val, i) => (
                        <div key={i} data-cy="INDICATOR">
                          <Indicators
                            type={
                              val === 1
                                ? "green"
                                // : val === -1
                                //   ? "yellow"
                                : "red"
                            }
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
            </div>

            <div
              className="display-flex flex-justify-content-space-around position-absolute"
              style={{
                width: "100%",
                borderTop: "1px solid #FFFFFF14",
                paddingTop: "12px",
                paddingBottom: "12px",
                gap: "16px",
                bottom: 0,
              }}
            >
              {[
                { label: "Present", color: "green" },
                { label: "Offline", color: "yellow" },
                { label: "Absent", color: "red" }
              ].map(({ label, color }) => (
                <div
                  key={color}
                  style={{ padding: "4px", display: "flex", alignItems: "center", gap: "4px" }}
                >
                  <Indicators size="10" type={color} />
                  <div className="">{label}</div>
                </div>
              ))}
            </div>
          </div>
        )
        } */}
      </div>
    </div>
  );
}

//  const TableCarousel = (props) => {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const tableConfigs = [
//     {
//       title: "COMPLAINTS",
//       headers: tableHeadings.complaints,
//       data: isValidObject(props.complaints)
//         ? convertToTableData(Object.values(props.complaints))
//         : [],
//       getField: complaintsTableField
//     },
//     {
//       title: "WORKFORCE",
//       headers: tableHeadings.workforce,
//       data: isValidObject(props?.workforce)
//         ? convertToTableData(Object.values(props?.workforce))
//         : [],
//       getField: workforceTableField
//     },
//     {
//       title: "PROCEDURE HISTORY",
//       headers: tableHeadings.procedureHistory,
//       data: isValidObject(props?.procedureHistory)
//         ? convertProcedureHistoryToTableData(
//             Object.values(props?.procedureHistory)
//           )
//         : [],
//       getField: procedureHistoryTableField
//     }
//   ];
//   const totalSlides = tableConfigs.length;

//   return (
//     <div
//       className="display-flex flex-direction-column over-flow-hidden margin-bottom-large margin-top-larger background-color-tertiaryColor1"
//       style={{ minHeight: "50%" }}
//     >
//       {/* Header */}
//       <div className="display-flex flex-justify-content-space-between flex-align-items-center padding-large font-color-tertiaryColor6">
//         <div className="display-flex flex-align-items-center">
//           <div className="margin-right-large">
//             {tableConfigs[currentIndex].title}
//           </div>
//           <GoToLogo />
//         </div>
//         <div className="display-flex" style={{ gap: "36px" }}>
//           <div
//             onClick={() => {
//               if (currentIndex > 0) {
//                 setCurrentIndex(currentIndex - 1);
//               }
//             }}
//             style={{
//               cursor: currentIndex === 0 ? "default" : "pointer",
//               transform: "rotate(90deg)",
//               opacity: currentIndex === 0 ? 0.3 : 1
//             }}
//           >
//             <ArrowIcon color="var(--tertiaryColor6)" />
//           </div>
//           <div
//             onClick={() => {
//               if (currentIndex < totalSlides - 1) {
//                 setCurrentIndex(currentIndex + 1);
//               }
//             }}
//             style={{
//               cursor: currentIndex === totalSlides - 1 ? "default" : "pointer",
//               transform: "rotate(270deg)",
//               opacity: currentIndex === totalSlides - 1 ? 0.3 : 1
//             }}
//           >
//             <ArrowIcon color="var(--tertiaryColor6)" />
//           </div>
//         </div>
//       </div>

//       {/* Carousel */}
//       <div
//         style={{
//           flex: 1,
//           position: "relative",
//           overflow: "hidden"
//         }}
//       >
//         <div
//           style={{
//             height: "100%",
//             display: "flex",
//             width: `${100 * totalSlides}%`,
//             transform: `translateX(-${(100 / totalSlides) * currentIndex}%)`,
//             transition: "transform 0.4s ease-in-out"
//           }}
//         >
//           {tableConfigs.map((config, index) => (
//             <div
//               key={index}
//               style={{
//                 width: `${100 / totalSlides}%`,
//                 flexShrink: 0,
//                 height: "100%"
//               }}
//               className="overflow-scroll"
//             >
//               <Table
//                 headers={config.headers}
//                 data={Array.isArray(config.data) ? config.data : []}
//                 getField={config.getField}
//                 allowCollapse={false}
//                 pagination={false}
//                 backgroundColor="var(--tertiaryColor1)"
//               />
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

//  const ChartCarousel = (props) => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const itemsPerPage = 2;

//   const chartData = [
//     {
//       title: "COMPLAINTS RAISED BY",
//       graph: (
//         <GraphCard
//           theme={"dark"}
//           isLoading={
//             !props.summary ||
//             !props.summary?.find((data) => data.title === "COMPLAINTS SOURCE")
//               ?.count
//           }
//           graph={
//             <DoughnutChart
//               data={getRaisedChartData(
//                 props.summary?.find(
//                   (data) => data.title === "COMPLAINTS SOURCE"
//                 )?.count
//               )}
//             />
//           }
//           legend={
//             <div className="display-flex flex-justify-content-center padding-top-large flex-direction-column">
//               {getRaisedChartData(
//                 props.summary?.find(
//                   (data) => data.title === "COMPLAINTS SOURCE"
//                 )?.count
//               )?.datasets[0].backgroundColor.map((data, i) => (
//                 <div key={i}>
//                   <LegendCard
//                     data={getRaisedChartData(
//                       props.summary?.find(
//                         (data) => data.title === "COMPLAINTS SOURCE"
//                       )?.count
//                     )}
//                     color={data}
//                     index={i}
//                   />
//                 </div>
//               ))}
//             </div>
//           }
//         />
//       )
//     },
//     {
//       title: "COMPLAINTS MONTHLY COMPARISON",
//       graph: (
//         <GraphCard
//           isLoading={
//             !props.summary ||
//             !props.summary?.find(
//               (data) => data.title === "COMPLAINTS MONTHLY COMPARISON"
//             )?.count
//           }
//           theme={"dark"}
//           type="bar"
//           graph={
//             <BarChart
//               data={getMonthlyComparisonBarChartData(
//                 props.summary?.find(
//                   (data) => data.title === "COMPLAINTS MONTHLY COMPARISON"
//                 )?.count
//               )}
//             />
//           }
//           legend={
//             <div
//               style={{
//                 paddingTop: "31px"
//               }}
//             />
//           }
//         />
//       )
//     },
//     {
//       title: "COMPLAINTS STATUS DATA",
//       graph: (
//         <GraphCard
//           isLoading={
//             !props.summary ||
//             !props.summary?.find(
//               (data) => data.title === "COMPLAINTS STATUS DATA"
//             )?.count
//           }
//           theme={"dark"}
//           graph={
//             <DoughnutChart
//               data={getStatusChartData(
//                 props.summary?.find(
//                   (data) => data.title === "COMPLAINTS STATUS DATA"
//                 )?.count
//               )}
//             />
//           }
//           legend={
//             <div className="display-flex flex-justify-content-center padding-top-large flex-direction-column">
//               {getStatusChartData(
//                 props.summary?.find(
//                   (data) => data.title === "COMPLAINTS STATUS DATA"
//                 )?.count
//               )?.datasets[0].backgroundColor.map((data, i) => (
//                 <div key={i}>
//                   <LegendCard
//                     data={getStatusChartData(
//                       props.summary?.find(
//                         (data) => data.title === "COMPLAINTS STATUS DATA"
//                       )?.count
//                     )}
//                     color={data}
//                     index={i}
//                   />
//                 </div>
//               ))}
//             </div>
//           }
//         />
//       )
//     },
//     {
//       title: "COMING SOON",
//       graph: (
//         <GraphCard
//           theme={"dark"}
//           comingSoon={true}
//           isLoading={false}
//           graph={
//             <DoughnutChart
//               data={getRaisedChartData(props.complaints?.todayComplaintsCount)}
//             />
//           }
//         />
//       )
//     }
//   ];

//   const lastIndex = Math.max(0, chartData.length - itemsPerPage);

//   return (
//     <div className="position-relative width-100-percentage height-100-percentage overflow-hidden">
//       <div className="display-flex flex-justify-content-space-between flex-align-items-center padding-bottom-small background-color-tertiaryColor1 overflow-hidden">
//         <div
//           className="display-flex transition-wrapper"
//           style={{
//             width: `calc(${(chartData.length / itemsPerPage) * 50}% - 16px)`,
//             transform: `translateX(-${(currentIndex / itemsPerPage) * 100}%)`,
//             transition: "transform 0.4s ease-in-out"
//           }}
//         >
//           {chartData.map((chart, index) => (
//             <div
//               key={index}
//               className="display-flex flex-direction-column"
//               style={{
//                 width: `${100 / itemsPerPage}%`,
//                 flex: `0 0 ${100 / itemsPerPage}%`,
//                 boxSizing: "border-box"
//               }}
//             >
//               <div className="display-flex flex-align-items-center flex-justify-content-space-between margin-bottom-small padding-large">
//                 <div
//                   onClick={() => {
//                     if (currentIndex > 0) {
//                       setCurrentIndex(currentIndex - itemsPerPage);
//                     }
//                   }}
//                   className="cursor-pointer padding-default"
//                   style={{
//                     transform: "rotate(90deg)",
//                     opacity: currentIndex === 0 ? 0.4 : 1,
//                     pointerEvents: currentIndex === 0 ? "none" : "auto",
//                     userSelect: "none"
//                   }}
//                 >
//                   {index % 2 === 0 && (
//                     <ArrowIcon color="var(--tertiaryColor6)" />
//                   )}
//                 </div>

//                 <div className="text-align-center font-size-medium font-color-tertiaryColor6">
//                   {chart.title}
//                 </div>

//                 <div
//                   onClick={() => {
//                     if (currentIndex < lastIndex) {
//                       setCurrentIndex(currentIndex + itemsPerPage);
//                     }
//                   }}
//                   className="cursor-pointer padding-default"
//                   style={{
//                     transform: "rotate(270deg)",
//                     opacity: currentIndex >= lastIndex ? 0.3 : 1,
//                     pointerEvents: currentIndex >= lastIndex ? "none" : "auto",
//                     userSelect: "none"
//                   }}
//                 >
//                   {index % 2 === 1 && (
//                     <ArrowIcon color="var(--tertiaryColor6)" />
//                   )}
//                 </div>
//               </div>

//               <div
//                 className="display-flex flex-direction-column background-color-tertiaryColor1 padding-default inherit-parent-height flex-align-items-center over-flow-hidden"
//                 style={{
//                   borderRadius: "8px"
//                 }}
//               >
//                 <div style={{ width: "100%" }}>{chart.graph}</div>
//                 {chart.legend && (
//                   <div className="margin-top-small" style={{ width: "100%" }}>
//                     {chart.legend}
//                   </div>
//                 )}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

//  const GraphCard = (props) => {
//   const theme =
//     getComputedStyle(document.documentElement).getPropertyValue(
//       "--primaryColor"
//     ) === "#0E0E0E"
//       ? "dark"
//       : "light";
//   return (
//     <div
//       style={{
//         minWidth: "0",
//         width: "100%",
//         height: "265px",
//         background:
//           props.isLoading || props.comingSoon
//             ? "transparent"
//             : "var(--tertiaryColor1)",
//         ...(props.comingSoon || props.isLoading
//           ? { border: "dashed 1px var(--tertiaryColor3)" }
//           : {})
//       }}
//       className={` padding-larger padding-larger flex-justify-content-space-between flex-direction-column position-relative`}
//       data-cy={`${props.comingSoon ? "COMING SOON" : props.title}${
//         props.isLoading ? "-loading" : ""
//       }`}
//     >
//       {!props.isLoading ? (
//         <>
//           {props.customData ? (
//             <div className="display-flex flex-align-items-center flex-justify-content-space-between">
//               {props.customData}
//             </div>
//           ) : (
//             <div className="display-flex flex-align-items-center flex-justify-content-space-between">
//               <div className="display-flex flex-align-items-center flex-justify-content-center flex-direction-column position-relative">
//                 <div
//                   style={{
//                     width:
//                       props.type === "line" || props.type === "bar"
//                         ? "105%"
//                         : "200px",
//                     height:
//                       props.type === "line" || props.type === "bar"
//                         ? "180px"
//                         : "180px",
//                     filter: props.comingSoon ? "blur(16px)" : "none",
//                     pointerEvents: props.comingSoon ? "none" : "auto"
//                   }}
//                 >
//                   {props.graph}
//                 </div>
//               </div>

//               {props.legend && <div>{props.legend}</div>}
//             </div>
//           )}
//         </>
//       ) : (
//         <>
//           <div
//             className={theme === "dark" ? "shimmer-dark" : "shimmer-light"}
//             style={{ width: "100%", height: "40px" }}
//           />
//           <div
//             className={theme === "dark" ? "shimmer-dark" : "shimmer-light"}
//             style={{ width: "100%", height: "154px", marginTop: "24px" }}
//           />
//         </>
//       )}
//     </div>
//   );
// };

//  const UploadPictureAndCarousel = (props) => {
//   const [selectedFile, setSelectedFile] = useState(null);
//   const fileInputRef = useRef(null);

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
//       props.setErrorStatus?.({
//         code: "custom",
//         message: "Kindly upload a valid image file (.jpg, .jpeg, .png)"
//       });
//       return;
//     }

//     setSelectedFile(URL.createObjectURL(file));
//   };

//   const handleUploadClick = () => {
//     if (!props?.images || props?.images?.length < 5) {
//       fileInputRef.current?.click();
//     }
//   };
//   const renderUploadBox = () => (
//     <div
//       className="font-color-tertiaryColor6 flex-justify-content-center flex-direction-column flex-align-items-center"
//       onClick={handleUploadClick}
//       style={{
//         height: "265px",
//         background: "transparent",
//         border: "dashed 2px var(--tertiaryColor5)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         cursor: "pointer"
//       }}
//     >
//       <div className="margin-bottom-large">
//         <UploadIcon />
//       </div>
//       <div>Click to upload PCT photo</div>
//       <div className="font-size-small margin-top-small">
//         Max 100KB - JPEG or PNG only
//       </div>
//     </div>
//   );
//   return (
//     <div className="">
//       <input
//         type="file"
//         accept=".jpg,.jpeg,.png"
//         ref={fileInputRef}
//         style={{ display: "none" }}
//         onChange={handleFileChange}
//         onClick={(e) => (e.target.value = "")}
//       />

//       {!props?.images || props?.images?.length === 0 ? (
//         renderUploadBox()
//       ) : (
//         <Carousel
//           showThumbs={false}
//           showArrows={true}
//           showStatus={false}
//           infiniteLoop={false}
//           showIndicators={false}
//         >
//           {props?.images?.map((src, index) => (
//             <div
//               key={index}
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 height: "100%",
//                 backgroundColor: "var(--tertiaryColor1)"
//               }}
//             >
//               <img
//                 src={src}
//                 alt={`Uploaded ${index}`}
//                 style={{
//                   maxHeight: "265px",
//                   maxWidth: "100%",
//                   objectFit: "contain"
//                 }}
//               />
//             </div>
//           ))}

//           {props?.images?.length < 5 && <div>{renderUploadBox()}</div>}
//         </Carousel>
//       )}

//       <Modal
//         show={Boolean(selectedFile)}
//         canIgnore={true}
//         onClose={() => setSelectedFile(null)}
//         width="width-60-percentage"
//         maxWidth="max-width-800px"
//         maxHeight="max-height-80-percentage"
//         background="false"
//         boxShadow="false"
//         borderRadius="false"
//         height="height-80-percentage"
//       >
//         <div
//           data-cy="cropper-modal"
//           className={`font-family-gilroy-regular font-color-tertiaryColor6 background-color-tertiaryColor1`}
//         >
//           <CropperModal
//             className="border-radius-default"
//             file={selectedFile}
//             setFile={() => setSelectedFile(null)}
//             OnBlobCreate={(blob) => {
//               const cropped = new File([blob], `${+new Date()}.png`, {
//                 type: "image/png"
//               });
//               setSelectedFile(null);

//               props.onUpload?.(cropped, props.locationId);
//             }}
//           />
//         </div>
//       </Modal>
//     </div>
//   );
// };

// const tableHeadings = {
//   complaints: [
//     { title: "COMPLAINT ID", width: "100px", textAlign: "left" },
//     { title: "DESCRIPTION", width: "340px", textAlign: "left" },
//     { title: "SOURCE", width: "180px", textAlign: "left" },
//     { title: "RAISED AT", width: "150px", textAlign: "left" }
//   ],

//   workforce: [
//     { title: "SI.No", width: "50px", textAlign: "left" },
//     { title: "NAME", width: "180px", textAlign: "left" },
//     { title: "ROLE", width: "180px", textAlign: "left" },
//     {
//       title: "CONTACT",
//       width: "180px",
//       textAlign: "left",
//       textTransform: "lowercase"
//     },
//     {
//       title: "ATTENDANCE",
//       width: "100px",
//       textAlign: "right",
//       textTransform: "uppercase"
//     }
//   ],

//   procedureHistory: [
//     { title: "NAME", width: "220px", textAlign: "left" },
//     { title: "TYPE", width: "100px", textAlign: "left" },
//     { title: "COMPLETED BY", width: "180px", textAlign: "left" },
//     { title: "CREATED AT", width: "180px", textAlign: "right" }
//   ]
// };

function EditLocationStatusModal(props) {
  const [formData, setFormData] = useState({
    status: props.currentStatus?.state,
    reason: props.currentStatus?.reason ?? ""
  });

  useEffect(() => {
    setFormData({
      status: props.currentStatus?.state,
      reason: props.currentStatus?.reason ?? ""
    });
    // eslint-disable-next-line
  }, [props.currentStatus?.state, props.show]);

  const isInactive = formData.status === "Inactive";
  const isStatusUnchanged = formData.status === props.currentStatus?.state;
  const isReasonUnchanged =
    formData.reason.trim() === (props.currentStatus?.reason ?? "").trim();

  const isSubmitDisabled =
    (isStatusUnchanged && isReasonUnchanged) ||
    (isInactive && formData.reason.trim().length === 0) ||
    props.loading;

  const handleSubmit = () => {
    if (isSubmitDisabled) return;
    props.onSubmit({
      status: formData.status,
      reason: isInactive ? formData.reason.trim() : ""
    });
    props.onClose();
  };

  return (
    <Modal
      show={props.show}
      canIgnore={true}
      onClose={props.onClose}
      width="inherit-parent-width"
      maxWidth="none"
      minWidth="none"
      height="none"
      background="background-color-tertiaryColor2"
      position="position-absolute bottom-0 right-0 left-0"
      borderRadius="false"
      transparentBackgroundColor={true}
    >
      <div
        className="font-color-tertiaryColor margin-larger"
        style={{ width: "calc(100% - 48px)" }}
        data-cy="STATUS-MODAL"
      >
        <div className="display-flex flex-justify-content-center flex-direction-column flex-align-items-center margin-bottom-larger">
          <div className="font-size-large margin-bottom-small">
            Edit location status
          </div>
          <div className="font-color-tertiaryColor6 font-size-medium">
            Update the current status for this location
          </div>
        </div>

        <div>
          <div
            className="display-flex flex-justify-content-space-between padding-vertical-large cursor-pointer"
            onClick={() =>
              setFormData((prev) => ({ ...prev, status: "Active" }))
            }
          >
            <div className="font-color-tertiaryColor font-size-medium">
              Active
            </div>
            {formData.status === "Active" ? (
              <RadioBoxActiveIcon color="var(--secondaryColor)" />
            ) : (
              <RadioBoxInActiveIcon />
            )}
          </div>

          <div
            className="display-flex flex-justify-content-space-between padding-vertical-large cursor-pointer"
            onClick={() =>
              setFormData((prev) => ({ ...prev, status: "Inactive" }))
            }
          >
            <div className="font-color-tertiaryColor font-size-medium">
              Inactive
            </div>
            {formData.status === "Inactive" ? (
              <RadioBoxActiveIcon color="var(--secondaryColor)" />
            ) : (
              <RadioBoxInActiveIcon />
            )}
          </div>
        </div>

        {isInactive && (
          <div className="margin-top-default">
            <InputBox
              className="inherit-parent-width font-color-tertiaryColor"
              name="reason"
              label="Reason"
              type="text"
              removeResponsive={true}
              autoComplete="off"
              value={formData.reason}
              data-cy="reason-field"
              required
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, reason: e.target.value }))
              }
            />
          </div>
        )}

        <Button
          boxShadow={false}
          type="button"
          variant="primary"
          text="Change status"
          className="margin-top-large"
          disabled={isSubmitDisabled}
          onClick={handleSubmit}
          data-cy="Change-status-button"
        />
      </div>
    </Modal>
  );
}
